import type {
  Datalayer,
  DatalayerStreamSideEffect,
  GDDLEvent,
} from '@analytics/models';
import { Injectable } from '@angular/core';

/**
 * Side Effect that tracks the duration of a page visit.
 * When a 'page-impression' event is received, it starts a debounce timer.
 * If no new 'page-impression' events are received within the debounce period,
 * a 'quality-visit' event is triggered to record the page visit duration.
 */
@Injectable()
export class QualityVisitSideEffect implements DatalayerStreamSideEffect {
  // Duration in seconds after which the quality-visit event will be fired
  private readonly seconds = 60;
  private hasBeenTriggered = false;

  /**
   * When a 'page-impression' event is received, it triggers the creation of the debounced duration event.
   *
   * @param event$ The observable stream of GDDLEvents.
   */
  process(event: GDDLEvent, datalayer: Datalayer) {
    if (this.hasBeenTriggered || event.event !== 'page-impression') {
      return;
    }
    setTimeout(() => {
      datalayer.pushEvent({
        event: 'quality-visit',
        info: { duration: this.seconds },
      });
    }, this.seconds * 1000);
    this.hasBeenTriggered = true;
  }
}
